import React, { useState } from "react";
import { BeverageLandingV5 } from "../BeverageV5/BeverageLanding";
import { BeverageV6 } from "../BeverageV6/Beverages";
import { BeverageV7 } from "../BeverageV7/Beverages";

const STORAGE_KEY = "beverages-split.variant";

const getVariant = () => {
  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (stored !== null) return Number(stored);

  const variant = Math.floor(Math.random() * 3);
  sessionStorage.setItem(STORAGE_KEY, variant);
  return variant;
};

export const BeveragesSplit = () => {
  const [variant] = useState(getVariant);

  if (variant === 0) return <BeverageLandingV5 />;
  if (variant === 1) return <BeverageV6 />;
  return <BeverageV7 />;
};
